<script>
  import { pop } from "svelte-spa-router";
  import { business } from "../stores.js";
  import LoadingAnim from "./LoadingAnim.svelte";
  import * as BusinessDAL from "../dal/business-dal";
  import * as BusinessBL from "../bl/business-bl";
  import { onMount } from "svelte";
  import FaExclamationCircle from "svelte-icons/fa/FaExclamationCircle.svelte";
  import { showPopup, loyaltyRules } from "../stores";

  export let itemDraft;
  let errorMsg = "";

  export let mode; //edit or new

  let menuItems = [];
  let selectedMenuItemIdx;
  let selectedRewardMenuItemIdx;

  let isSaving = false;

  let showDeactivationPopup = false;

  async function addCollectibleItem(menuItemIdx) {
    console.log($loyaltyRules);

    let itemId = menuItems[menuItemIdx].id;
    let existingItem = $loyaltyRules.find((rule) => {
      if (rule.collectibleItems.find((item) => item.id == itemId)) {
        errorMsg = `הפריט כבר קיים בכרטיסיה: ${rule.title}`;
        return true;
      }
    });

    if (existingItem) {
      return;
    } else {
      errorMsg = "";
    }

    let item = menuItems[menuItemIdx];
    if (!item) return;

    if (itemDraft.collectibleItems.filter((x) => x.id == item.id).length == 0) {
      itemDraft.collectibleItems.push(item);
      itemDraft = itemDraft;
    }
  }

  function removeCollectibleItem(idx) {
    itemDraft.collectibleItems.splice(idx, 1);
    itemDraft = itemDraft;
  }

  function addRewardItem(menuItemIdx) {
    let item = menuItems[menuItemIdx];
    if (!item) return;

    if (itemDraft.rewardItems.filter((x) => x.id == item.id).length == 0) {
      itemDraft.rewardItems.push(item);
      itemDraft = itemDraft;
    }
  }

  function removeRewardItem(idx) {
    itemDraft.rewardItems.splice(idx, 1);
    itemDraft = itemDraft;
  }

  function validateAll() {
    if (!itemDraft.title || itemDraft.title.length < 3) {
      errorMsg = "נא להזין שם למבצע";
    } else if (itemDraft.collectibleItems.length == 0) {
      errorMsg = "נא להזין מוצרים לצבירה";
    } else if (itemDraft.rewardItems.length == 0) {
      errorMsg = "נא להזין מוצר שמקבלים מתנה";
    } else {
      errorMsg = "";
    }
  }

  async function saveLoyaltyItem() {
    errorMsg = "";
    isSaving = true;

    itemDraft.collectibleItems.sort((a, b) => a.id - b.id);
    itemDraft.rewardItems.sort((a, b) => a.id - b.id); // order of items doesnt matter for the object hash

    itemDraft.businessTitle = $business.title;

    try {
      if (mode == "edit") {
        await BusinessBL.updateLoyaltyRule(itemDraft);
      } else {
        await BusinessBL.saveNewLoyaltyRule(itemDraft);
      }
      await pop();
    } catch (err) {
      errorMsg = err.message ?? err.toString();
    } finally {
      isSaving = false;
    }
  }

  $: {
    if ($business?.menu) {
      menuItems = [];
      $business.menu.forEach((section) => {
        section.items.forEach((item) => {
          menuItems.push({ name: item.name, id: item.id });
        });
      });
      menuItems = menuItems;
    }
  }

</script>

<main>
  <div class="form" on:click|stopPropagation>
    {#if errorMsg}
      <div class="error">
        <div class="errorIcon">
          <FaExclamationCircle />
        </div>
        <span class="errorLabel"> {errorMsg} </span>
      </div>
    {/if}

    <div>
      <div class="title">
        <input
          type="checkbox"
          bind:checked={itemDraft.active}
          on:change={() => {
            if (!itemDraft.active) {
              showDeactivationPopup = true;
            }
          }}
        />
        <h2>כרטיסיה פעילה</h2>
        <input
          class="titleInput"
          type="text"
          bind:value={itemDraft.title}
          class:inactive={!itemDraft.active}
        />
      </div>
    </div>
    <div class="wrapper" class:inactive={!itemDraft.active}>
      <div class="list section">
        <div class="countInputSection">
          <label class="collectibleCount" for="collectibleCount">קנה</label>
          <input
            class="priceVar"
            name="collectibleCount"
            type="number"
            min="1"
            bind:value={itemDraft.collectibleCount}
          />
          <span class="collectibleCount">מהמוצרים הבאים:</span>
        </div>
        <span class="addItemInputs">
          <select
            name="category"
            id="category"
            bind:value={selectedMenuItemIdx}
          >
            <option disabled selected value>בחירת מוצר</option>
            {#each menuItems as item, idx (item.id)}
              <option value={idx}>{item.name}</option>
            {/each}
          </select>
          <button
            class="addBtn"
            on:click={addCollectibleItem(selectedMenuItemIdx)}
          >הוספה</button>
        </span>
        <div class="items">
          {#each itemDraft.collectibleItems as item, idx (item.id)}
            <span class="collectibleItem">
              <button
                class="removeCityBtn"
                on:click={() => {
                  removeCollectibleItem(idx);
                }}
              >x</button>
              {item.name}
            </span>
          {/each}
        </div>
      </div>

      <div class="list section">
        <div class="countInputSection">
          <label class="collectibleCount" for="collectibleCount">קבל מתנה אחד
            מהמוצרים הבאים:</label>
        </div>
        <span class="addItemInputs">
          <select
            name="category"
            id="category"
            bind:value={selectedRewardMenuItemIdx}
          >
            <option disabled selected value hidden>בחירת מוצר</option>
            {#each menuItems as item, idx}
              <option value={idx}>{item.name}</option>
            {/each}
          </select>
          <button
            class="addBtn"
            on:click={addRewardItem(selectedRewardMenuItemIdx)}
          >הוספה</button>
        </span>
        <div class="items">
          {#each itemDraft.rewardItems as item, idx (item.id)}
            <span class="collectibleItem">
              <button
                class="removeCityBtn"
                on:click={() => {
                  removeRewardItem(idx);
                }}
              >x</button>
              {item.name}
            </span>
          {/each}
        </div>
      </div>
    </div>

    <div class="buttons">
      <button
        class="save"
        on:click|preventDefault|stopPropagation={async () => {
          validateAll();

          if (!errorMsg) {
            if (!itemDraft.active && showDeactivationPopup) {
              showPopup('האם אתה בטוח? לקוחות שצברו חתימות בכרטיסיה יוכלו להשלים אותה עד לקבלת המתנה', saveLoyaltyItem);
            } else {
              showPopup('האם אתה בטוח?', saveLoyaltyItem);
            }
          }
        }}
      >{#if isSaving}
          <div class="btnLoadingAnim">
            <LoadingAnim />
          </div>
        {:else}שמירה{/if}
      </button>
      <button class="cancel" on:click={pop}>ביטול</button>
    </div>
  </div>
</main>

<style>
  .error {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: var(--red1);
  }

  select:disabled {
    color: gray;
  }

  .errorIcon {
    width: 20px;
  }
  .inactive {
    color: #bbb;
    pointer-events: none;
  }
  .title {
    display: flex;
    align-items: center;
  }

  .title > h2 {
    min-width: fit-content;
    margin-left: 10px;
    margin-right: 10px;
    font-weight: 500;
  }
  .section {
    margin-bottom: 25px;
  }
  .addItemInputs {
    display: flex;
    align-items: center;
  }
  .addItemInputs > select {
    padding: 8px;
    border-radius: 4px;
    margin: 0;
    font-size: 14px;
  }
  .titleInput {
    width: 100%;
  }

  .addBtn {
    max-height: 2.25em;
    padding: 5px 11px;
    border-radius: 4px;
    border: 1px solid #4b4b4b26;
  }

  .buttons {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    gap: 20px;
  }

  .buttons > button {
    width: 100%;
    color: white;
    margin: 0;
  }

  button,
  button {
    height: 45px;
    outline: none;
    border: none;
    padding: 10px;
    font-size: 16px;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 10px;
  }
  .save,
  .save:active {
    background: var(--green1);
  }

  .save:disabled {
    background: gray;
    cursor: default;
  }

  .cancel,
  .cancel:active {
    background: var(--red1);
  }
  main {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  input {
    margin-top: 5px;
    outline: none;
    border: 2px solid #e6e6e6;
    padding: 5px;
    font-size: 12px;
    border-radius: 10px;
  }

  input:focus {
    border: 2px solid black;
  }
  .form {
    min-width: 480px;
    width: 100%;
    max-width: 560px;
    background: white;
    direction: rtl;
    padding: 18px;
    border-radius: 3px;
    box-shadow: 0 20px 25px -20px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
  }

  .collectibleCount {
    display: inline-flex;
    align-items: center;
    font-size: 16px;
    margin-bottom: 12px;
  }

  .priceVar {
    width: 50px;
    border-radius: 10px;
    margin-right: 7px;
  }

  .dateField {
    /* width: 50px; */
    border-radius: 10px;
    margin-right: 7px;
  }

  .errorLabel {
    color: var(--red1);
    margin-right: 10px;
  }

  .collectibleItem {
    padding: 5 px;
    margin-left: 5 px;
    font-size: 14px;
  }

  .items {
    padding-right: 10px;
    font-size: 12px;
    margin-top: 18px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .removeCityBtn {
    width: 20px;
    height: 20px;
    background: var(--red1);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: white;
    border-radius: 100px;
    margin-left: 10px;
    margin-bottom: 0;
    font-size: 14px;
    line-height: 14px;
    border: none;
  }

  .addBtn {
    max-height: 2.25em;
    padding: 5px 11px;
    border-radius: 4px;
  }

  .btnLoadingAnim {
    width: 100%;
    height: 100%;
    transform: scale(0.5) translateY(-25px);
  }

</style>
